(ns lemonpi.domain.interface.permission
  (:require [malli.core :as m]))

;;
;; Permissions
;;

(def permissions
  {:adservers/create {:description "Create Adservers"},
   :adservers/delete {:description "Delete Adservers"},
   :adservers/edit {:description "Edit Adservers"},
   :adservers/view {:description "View Adservers"},

   :adsets2/content {:description "Content Adsets2"},
   :adsets2/create {:description "Create Adsets2"},
   :adsets2/delete {:description "Delete Adsets2"},
   :adsets2/edit {:description "Edit Adsets2"},
   :adsets2/export {:description "Export Adsets2"},
   :adsets2/templates {:description "Templates Adsets2"},
   :adsets2/trackers {:description "Trackers Adsets2"},
   :adsets2/view {:description "View Adsets2"},

   :advertisers/create {:description "Create Advertisers"},
   :advertisers/delete {:description "Delete Advertisers"},
   :advertisers/edit {:description "Edit Advertisers"},
   :advertisers/view {:description "View Advertisers"},

   :campaigns/create {:description "Create Campaigns"},
   :campaigns/delete {:description "Delete Campaigns"},
   :campaigns/edit {:description "Edit Campaigns"},
   :campaigns/view {:description "View Campaigns"},

   :products/configure {:description "Configure Products"},
   :products/edit {:description "Edit Products"},
   :products/view {:description "View Products"},

   :roles/create {:description "Create Roles"},
   :roles/delete {:description "Delete Roles"},
   :roles/edit {:description "Edit Roles"},
   :roles/view {:description "View Roles"},

   :templates/create {:description "Create Templates"},
   :templates/delete {:description "Delete Templates"},
   :templates/edit {:description "Edit Templates"},
   :templates/view {:description "View Templates"},

   :useraccounts/create {:description "Create Useraccounts"},
   :useraccounts/delete {:description "Delete Useraccounts"},
   :useraccounts/edit {:description "Edit Useraccounts"},
   :useraccounts/view {:description "View Useraccounts"}

   ;; virtual system permissions
   :system/read {:description "Read system"}

   ;; Never add this permission to the set of permissions users can have.
   :system/internal {:description "Permission used for internal services to make requests to the dispatcher. Requests that come from the frontend can never have this permission, therfore events with this permission can only be called by a service with access to the same private network as the dispatcher."}

   ;; az permissions
   :cc-superadmin-access "Superadmin Access"})

(def Permission (m/schema (into [:enum] (keys permissions))))

(defn policy->permissions
  "Map the legacy policy information into set of permissions. Special
   permissions are added dynamically:

   - `:system/read` all users have this
   - `:system/admin` all admins have this

   NOTE: does not handle `allowedIfOwner` currently, these need to flattened to
   normal rights when they are needed."
  [{:keys [permissions az-permissions]}]
  (-> (set (for [[n d] permissions, [k v] d, :when v] (keyword (name n) (name k))))
      (conj :system/read)
      (into (when az-permissions (set (keys az-permissions))))))

(def superadmin-permissions #{:system/read, :system/write})
